// LandingApp.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './components/HomePage';
import TenderSelectionPage from './TenderSelectionPage';
import LoginPage from './LoginPage';
import SubscriptionPage from './SubscriptionPage';
import SubscriptionCheck from './SubscriptionCheck';
import ProtectedRoute from './ProtectedRoute'; // Import ProtectedRoute if needed
import AboutUs from './components/AboutUs'; // Import the About Us component
import Services from './components/Services'; // Import the Services component
import SubscriptionPricing from './components/SubscriptionPricing'; // Import the SubscriptionPricing component
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RefundPolicy from './pages/RefundPolicy';
import PricingPolicy from './pages/PricingPolicy';
import ContactUs from './pages/ContactUs';
import MyProfile from './components/MyProfile';
import FavoriteTenders from './components/FavoriteTenders';
import Reports from './components/Reports';
import { UserProvider } from './UserContext'; // Adjust the path as needed
import ActivePlanPage from './components/ActivePlanPage';
import ProtectedRouteForLoggedInUsers from './ProtectedRouteForLoggedInUsers'; // Adjust the path if necessary
import GeMCategories from "./components/GeMCategories"; // Adjust the path as necessary
import GovernmentPortals from './components/GovernmentPortals';
import ProcurementRules from './components/ProcurementRules'; // New component
import GovtOrgAndDepts from './components/GovtOrgAndDepts'; // New component
import ReportsPricing from "./components/ReportsPricing";
import ActiveSessions from './components/ActiveSessions';
import TestReportsPage from './components/TestReportsPage';
import TestStateReportsPage from './components/TestStateReportsPage';
import TestMinistryReportsPage from './components/TestMinistryReportsPage';
import TestServiceReportsPage from './components/TestServiceReportsPage';
import ReportsComboSubscriptionPage from './components/ReportsComboSubscriptionPage'; // deprecated
import { Navigate } from 'react-router-dom';
import GemV2BidsPage from "./components/gemv2/GemV2BidsPage";
import GemV2ResultsPage from "./components/gemv2/GemV2ResultsPage";
import CpppV2TendersPage from "./components/cpppv2/CpppV2TendersPage";
import TendermakerHome from "./components/tendermaker/TendermakerHome";
import BidAnalyzerPage from "./components/tendermaker/BidAnalyzerPage";
import ProfileVaultPage from "./components/tendermaker/ProfileVaultPage";
import BidWorkspacePage from "./components/tendermaker/BidWorkspacePage";
import BidDetailUploadPage from "./components/tendermaker/BidDetailUploadPage";
import BidStudioPage from "./components/tendermaker/BidStudioPage";
import CpppV2ResultsPage from "./components/cpppv2/CpppV2ResultsPage";
import GeMContractsDashboardPage from "./components/gemv2/GeMContractsDashboardPage";
import CpwdTenderResultsClientPage from "./components/cpwd/CpwdTenderResultsClientPage";
import AdminRoute          from './components/admin/AdminRoute';
import AdminDashboardPage  from './components/admin/AdminDashboardPage';
import AdminUsersPage      from './components/admin/AdminUsersPage';
import AdminAlertsPage     from './components/admin/AdminAlertsPage';
import AdminUserDetailPage from './components/admin/AdminUserDetailPage';
import AdminGemCleanedContractsDashboardPage from "./components/admin/AdminGemCleanedContractsDashboardPage";
import AdminCpwdTenderResultsPage from "./components/admin/AdminCpwdTenderResultsPage";
import AdminIntelligencePage from "./components/admin/AdminIntelligencePage";



function LandingApp() {
  return (
    <UserProvider>
    <Router>
      <Routes>
        {/* Home Page - Default Route */}
        <Route path="/" element={<HomePage />} /> {/* New route for HomePage */}

        {/* GeM V2 Pages Temp */}
        <Route
          path="/gem-v2/bids"
          element={
            <ProtectedRoute>
              <GemV2BidsPage />
            </ProtectedRoute>
          }
        />
        <Route path="/gem-v2-results" element={<ProtectedRoute><GemV2ResultsPage /></ProtectedRoute>} />
        <Route path="/GeM-contracts-dashboard" element={<ProtectedRoute><GeMContractsDashboardPage /></ProtectedRoute>} />
        <Route path="/cppp-v2-results" element={<ProtectedRoute><CpppV2ResultsPage /></ProtectedRoute>} />
        <Route path="/cpwd-tender-results" element={<ProtectedRoute><CpwdTenderResultsClientPage /></ProtectedRoute>} />

        <Route
          path="/cppp-tenders"
          element={
            <ProtectedRoute>
              <CpppV2TendersPage />
            </ProtectedRoute>
          }
        />    


        {/* GeM Categories Page */}
        <Route path="/resources/gem-categories" element={<GeMCategories />} />

        {/* Govt Portals Page */}
        <Route path="/resources/government-portals" element={<GovernmentPortals />} />
        <Route path="/resources/procurement-rules" element={<ProcurementRules />} />
        <Route path="/resources/govt-orgs-and-depts" element={<GovtOrgAndDepts />} />

        {/* tender maker routes */}
        <Route path="/tendermaker" element={<ProtectedRoute><TendermakerHome /></ProtectedRoute>} />

        <Route path="/tendermaker/analyzer" element={<ProtectedRoute><BidAnalyzerPage /></ProtectedRoute>} />
        <Route path="/tendermaker/profile" element={<ProtectedRoute><ProfileVaultPage /></ProtectedRoute>} />
        <Route path="/tendermaker/bids" element={<ProtectedRoute><BidWorkspacePage /></ProtectedRoute>} />
        <Route path="/tendermaker/bids/:bidId" element={<ProtectedRoute><BidDetailUploadPage /></ProtectedRoute>} />

        <Route path="/tendermaker/bid-studio" element={<ProtectedRoute><BidStudioPage /></ProtectedRoute>} />



        {/* Other routes */}
        <Route path="/about" element={<AboutUs />} />

        {/* Other routes */}
        <Route path="/services" element={<Services />} />

        {/* Other routes */}
        <Route path="/subscription-pricing" element={<SubscriptionPricing />} />

        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/pricing-policy" element={<PricingPolicy />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/reports-pricing" element={<ReportsPricing />} />
        <Route path="/reports-combo-subscription" element={<Navigate to="/subscription-pricing" replace />} />
        {/* Other routes */}

        <Route
  path="/my-profile"
  element={
    <ProtectedRouteForLoggedInUsers>
      <MyProfile />
    </ProtectedRouteForLoggedInUsers>
  }
/>
<Route
  path="/active-plan"
  element={
    <ProtectedRouteForLoggedInUsers>
      <ActivePlanPage />
    </ProtectedRouteForLoggedInUsers>
  }
/>
<Route
  path="/favorite-tenders"
  element={
    <ProtectedRouteForLoggedInUsers>
      <FavoriteTenders />
    </ProtectedRouteForLoggedInUsers>
  }
/>
<Route
  path="/reports"
  element={
    <ProtectedRouteForLoggedInUsers>
      <Reports />
    </ProtectedRouteForLoggedInUsers>
  }
/>
<Route
  path="/sessions"
  element={
    <ProtectedRouteForLoggedInUsers>
      <ActiveSessions />
    </ProtectedRouteForLoggedInUsers>
  }
/>
<Route
  path="/product-reports"
  element={
    <ProtectedRouteForLoggedInUsers>
      <TestReportsPage />
    </ProtectedRouteForLoggedInUsers>
  }
/>
<Route
  path="/state-reports"
  element={
    <ProtectedRouteForLoggedInUsers>
      <TestStateReportsPage />
    </ProtectedRouteForLoggedInUsers>
  }
/>
<Route
  path="/ministry-reports"
  element={
    <ProtectedRouteForLoggedInUsers>
      <TestMinistryReportsPage />
    </ProtectedRouteForLoggedInUsers>
  }
/>
<Route
  path="/service-reports"
  element={
    <ProtectedRouteForLoggedInUsers>
      <TestServiceReportsPage />
    </ProtectedRouteForLoggedInUsers>
  }
/>

        {/* Admin pages — only accessible to phones listed in ADMIN_PHONES env var */}
        <Route path="/admin"               element={<AdminRoute><AdminDashboardPage  /></AdminRoute>} />
        <Route path="/admin/users"         element={<AdminRoute><AdminUsersPage      /></AdminRoute>} />
        <Route path="/admin/alerts"        element={<AdminRoute><AdminAlertsPage     /></AdminRoute>} />
        <Route path="/admin/users/:phone"  element={<AdminRoute><AdminUserDetailPage /></AdminRoute>} />
        <Route path="/admin/gem-cleaned-contracts" element={<AdminRoute><AdminGemCleanedContractsDashboardPage /></AdminRoute>} />
        <Route path="/admin/cpwd-tender-results" element={<AdminRoute><AdminCpwdTenderResultsPage /></AdminRoute>} />
        <Route path="/admin/intelligence" element={<AdminRoute><AdminIntelligencePage /></AdminRoute>} />

        {/* Login Page */}
        <Route path="/login" element={<LoginPage />} />

        {/* Subscription Check */}
        <Route path="/subscription-check" element={<SubscriptionCheck />} />

        {/* Subscription Page */}
        <Route path="/subscription" element={<SubscriptionPage />} />

        {/* Tender Selection Page */}
        <Route
          path="/tender-selection"
          element={
            <ProtectedRoute>
              <TenderSelectionPage />
            </ProtectedRoute>
          }
        />

      </Routes>
    </Router>
    </UserProvider>  
  );
}

export default LandingApp;
